import module from 'viaticos/module.js'
import template from './template.html'

export class ViaticosPagosLauncherComponent {
}

module.component('viaticosPagosLauncher', {
  controller: ViaticosPagosLauncherComponent,
  template,
})



// WEBPACK FOOTER //
// ./src/viaticos/components/pagos/launcher/component.js